import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

declare var $: any;

@Component({
	selector: 'app-frontend-panel',
	templateUrl: './FrontendPanelNoFooter.component.html'
})
export class FrontendPanelNoFooterLayoutComponent implements OnInit {

	private _router: Subscription;
	url: string;

	isFooter = true;

	constructor(private router: Router) { }

	ngOnInit() {
	}
	/**
	 * On window scroll add class header-fixed.
	 */
	@HostListener('window:scroll', ['$event'])
	onScrollEvent($event) {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		if (scrollTop >= 200) {
			document.querySelector('app-frontend-panel').classList.add('header-fixed');
		} else {
			document.querySelector('app-frontend-panel').classList.remove('header-fixed');
		}
	}
}
